import React, { useEffect, useState } from "react";
import { TextField, Select, MenuItem, InputLabel, FormControl } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import SimuladorNumericInput from "./SimuladorNumericInput";
import BuildIcon from '@mui/icons-material/Build';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import { SimuladorIncentivosRRiego } from "./SimuladorIncentivosRRiego";
import { SimuladorIncentivosRRefacciones } from "./SimuladorIncentivosRRefacciones";
import { SimuladorIncentivoORBasico } from "./SimuladorIncentivoORBasico";
import ConnectingAirportsIcon from '@mui/icons-material/ConnectingAirports';


const SimuladorIncentivosFerreteriaScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
        sucursal: ""
    });

    const [porcIncentivo, setPorcIncentivo] = useState(0)


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    //FERRETERIA
    const [sucursal, setSucursal] = useState("")
    const [adr, setAdr] = useState("")

    const handleAdrChange = (e) => {
        setSucursal(e.target.value)

        if (Number(e.target.value) % 2 === 0)
            setAdr("2");
        else {
            setAdr("1");

        }

    };

    const rangoSinaloa = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0050 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0060 },
        { minimo: 90, maximo: 99.99, porcentaje: 0.0070 },
        { minimo: 100, maximo: 109.99, porcentaje: 0.01 },
        { minimo: 110, maximo: 119.99, porcentaje: 0.0110 },
        { minimo: 120, maximo: 150000, porcentaje: .0120 },
    ]

    const rangoNayarit = [
        { minimo: 0, maximo: 79.99, porcentaje: 0.0150 },
        { minimo: 80, maximo: 89.99, porcentaje: 0.0160 },
        { minimo: 90, maximo: 99.99, porcentaje: .0170 },
        { minimo: 100, maximo: 109.99, porcentaje: .02 },
        { minimo: 110, maximo: 119.99, porcentaje: .0230 },
        { minimo: 120, maximo: 150000, porcentaje: .0250 },
    ]


    //TOTALES
    const [totalRefacciones, setTotalRefacciones] = useState(0)
    const [totalFerreteria, setTotalFerreteria] = useState(0)
    const [totalRiego, setTotalRiego] = useState(0)
    const [totalDrones, setTotalDrones] = useState(0)
    const [totalVapormatic, setTotalVapormatic] = useState(0)

    const [totalIncentivo, setTotalIncentivo] = useState(0)


    useEffect(() => {
        let total = 0;

        total = totalRefacciones + totalFerreteria + totalRiego + totalDrones + totalVapormatic;

        setTotalIncentivo(total)

    }, [totalRefacciones, totalFerreteria, totalRiego, totalDrones, totalVapormatic]);

    return (
        <>
            <div className="simulador-incentivo-form-seccion">
                <FormControl fullWidth size="small" sx={{ mb: 2, background: '#dae6be' }}>
                    <InputLabel id="sucursal-label">Sucursal</InputLabel>
                    <Select
                        labelId="sucursal-label"
                        value={sucursal}
                        label="Sucursal"
                        onChange={(e) => handleAdrChange(e)}
                    >
                        <MenuItem value="1">Navolato</MenuItem>
                        <MenuItem value="2">Nayarit</MenuItem>

                    </Select>
                </FormControl>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <ConstructionIcon sx={{ fontSize: "18px" }} /> Ferreteria
                    </div>
                    <SimuladorIncentivosRRefacciones
                        rango={adr === "1" ? rangoSinaloa : adr === "2" ? rangoNayarit : null}
                        setIncentivo={setPorcIncentivo}
                        setTotal={setTotalFerreteria}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon sx={{ fontSize: "18px" }} /> Refacciones
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalRefacciones}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BathroomIcon sx={{ fontSize: "18px" }} /> Sistemas de Riego
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalRiego}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <ConnectingAirportsIcon sx={{ fontSize: "18px" }} /> Drones
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalDrones}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon sx={{ fontSize: "18px" }} /> Varios Vapormatic
                    </div>
                    <SimuladorIncentivoORBasico
                        porc_Incentivo={porcIncentivo ? porcIncentivo : 0}
                        setTotal={setTotalVapormatic}
                    />
                </div>
            </div >
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>
                    <SimuladorNumericInput
                        name="Total"
                        label=""
                        value={totalIncentivo}
                        disabled={true}
                        icono="none"
                        align="centro"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
        </>
    );
};

export default SimuladorIncentivosFerreteriaScreen;
